import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_ImageResizer = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/image-resizer',
			name: 'Image Resizer — Change Size of Image Online | Lift',
			description:
				'Resize your picture online to any dimension in seconds. No watermark. Upload your photo, adjust the size by pixels or aspect ratio, and download in high-res quality. Try now!',
			url: 'https://liftapp.ai/image-resizer',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/image-resizer#product' },
				{ '@id': 'https://liftapp.ai/image-resizer#howto' },
				{ '@id': 'https://liftapp.ai/image-resizer#benefits' },
				{ '@id': 'https://liftapp.ai/image-resizer#faq' },
				{ '@id': 'https://liftapp.ai/image-resizer#why-lift' },
				{ '@id': 'https://liftapp.ai/image-resizer#explore-tools' },
				{ '@id': 'https://liftapp.ai/image-resizer#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/image-resizer#product',
			name: 'Image Resizer Online',
			description:
				'Change the size of any image in seconds. Online picture resizer — set exact dimensions, adjust aspect ratio, and resize photo without losing quality ',
			url: 'https://liftapp.ai/image-resizer',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/image-resizer#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Drag to Resize',
					text: "Use the 'Drag to resize' slider to instantly adjust your image size, or enter custom dimensions for full control.",
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-resizer#benefits',
			name: 'Who can benefit from Image Resizer?',
			description:
				'Lift Image Resizer helps social media users, small business owners, e-commerce sellers, students, professionals, and content creators resize images for any platform or purpose.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Social Media Users — Resize photos for Instagram, TikTok, Facebook, and LinkedIn posts in seconds.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Small Business Owners — Change the size of images for website banners, email visuals, and paid ads.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'E-commerce Sellers — Meet strict image size requirements for Amazon, Etsy, and Shopify with ease.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Students & Professionals — Resize images for presentations, reports, resumes, and online submissions.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Content Creators — Quickly resize images without opening Photoshop or complex software.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Lift Image Resizer',
				description:
					'Lift online image resizer for social media, e-commerce, and business',
			},
		},
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/image-resizer#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift Image Resizer?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift Image Resizer is a online tool that lets you change the size of any image in seconds. You can resize photos by dragging a slider or entering exact pixel dimensions, making it ideal for social media, e-commerce, passport photos, presentations, and more. No software installation required.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift Image Resizer work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift Image Resizer lets you upload any photo and change its size in seconds. Use the drag-to-resize slider for quick adjustments, or manually enter exact width and height dimensions. You can also select a preset aspect ratio to resize your image for Instagram, passport size, or any custom format. No software needed — everything happens online in your browser.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I resize images without losing quality?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes. Lift uses smart processing to resize images while preserving as much quality as possible. Whether you're decreasing or increasing image size, your output stays sharp and clear.",
					},
				},
				{
					'@type': 'Question',
					name: 'Is it safe — do you store my images?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes, completely safe. Your images are processed securely and automatically deleted from our servers immediately after compression. We never store, share, or access your files — your privacy is our priority.',
					},
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-resizer#why-lift',
			name: 'Why Lift Image Resizer stands out',
			description:
				'High-quality results, intelligent rendering, cross-platform support, and budget-friendly pricing.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Change size of image',
				description:
					'Change size of image — quality, speed, and cross-platform support',
			},
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-resizer#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/image-resizer#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Image Resizer',
					item: 'https://liftapp.ai/image-resizer',
				},
			],
		},
	],
};
